import router from "src/routes/routes";
import { createCrudService } from "./crudFactory";
import CommonAPIService from "./commonHandler";

const api = new CommonAPIService(router);
const customRoutes = [
  { method: "POST", path: "/submit", handlerName: "submit" },
  { method: "PUT", path: "/:id/review", handlerName: "review" },
  { method: "GET", path: "/caregiver/:caregiverId", handlerName: "getByCaregiver" },
  { method: "GET", path: "/client/:clientId", handlerName: "getByClient" },
];

const baseService = createCrudService("caregiverTraining", customRoutes, router);

export const caregiverTrainingService = {
  ...baseService,
  list: (params) => api.getCall("/api/caregiverTraining", params), // Override to accept params

  // Submit a training completion request
  submit: async (clientId) => {
    return api.postCall(`/api/caregiverTraining/submit`, {
      id_clients: clientId
    });
  },

  // Review a training request (approve or reject)
  review: async (id, status, adminNotes = null) => {
    return api.putCall(`/api/caregiverTraining/${id}/review`, {
      status,
      admin_notes: adminNotes
    });
  },

  // Get training records for a specific caregiver
  getByCaregiver: async (caregiverId) => {
    return api.getCall(`/api/caregiverTraining/caregiver/${caregiverId}`);
  },

  // Get training records for a specific client
  getByClient: async (clientId) => {
    return api.getCall(`/api/caregiverTraining/client/${clientId}`);
  },

  // Get training records filtered by status
  getByStatus: async (status) => {
    return api.getCall(`/api/caregiverTraining`, { status });
  },

  // Get pending training requests for admin approval
  getPendingRequests: async () => {
    return api.getCall(`/api/caregiverTraining`, { status: 'pending' });
  },
};
